export enum SRPPageComponents {
  HotelCard = 'HotelCard',
  PopularLocationsWidget = 'PopularLocationsWidget',
  CityGuide = 'CityGuide',
  Filters = 'Filters',
  TopFilterCardLoaded = 'top_filter_card_loaded',
  TopFilterCard = 'TopFilterCard',
  SaleHandling = 'SaleHandling',
  MultiRoomHandlingCard = 'MultiRoomHandlingCard',
  BackfillPropertyViewHeading = 'BackfillPropertyViewed',
  LBICard = 'Loved_by_Indians_card',
  HourlyStayCard = 'HourlyStayCard',
  LUFCARD = 'Last_Used_Filter_Card',
  BankOfferCard = 'BankOfferCopyCode',
  spotlightIconClicked = 'spotlight_icon_clicked',
}

export enum SrpHotelCardIndexImpression {
  EleventhCard = '11th',
}

export const srpLoaded = {
  semCalendarOpen: 'sem_calendar_open',
  spotlightBottomSheetShown: 'spotlight_bottomsheet_shown',
};

export const srpClicks = {
  cityGuideClicks: {
    cityguide_card_click: 'cityguide_card_click',
    cityguide_screen_click: 'cityguide_screen_click',
  },
  topFilterClicks: {
    top_filter_card_enabled: 'top_filter_card_enabled',
    top_filter_card_disabled: 'top_filter_card_disabled',
  },
  lastUsedFilterClicks: {
    last_used_filter_apply_click: 'last_used_filter_apply_click',
  },
  saleHandling: {
    saleHandlingToggleApplied: 'saleHandling_toggle_applied',
    saleHandlingToggleRemoved: 'saleHandling_toggle_removed',
    lovedByIndiansClicked: 'Loved_by_Indians_clicked',
    lovedByIndiansToggleApplied: 'Loved_by_Indians_toggle_applied',
    lovedByIndiansToggleRemoved: 'Loved_by_Indians_toggle_removed',
    multiroomhandlingToggleApplied: 'multiroomhandling_toggle_applied',
    multiroomhandlingToggleRemoved: 'multiroomhandling_toggle_removed',
  },
  hourly: {
    filtersClicked: 'Filters_Clicked',
    modifyClicked: 'Modify_Clicked',
    cardClicked: 'Card_clicked',
    bannerCTAClicked: 'BannerCTAclicked',
    topFilterDuration: 'TopFilter_Duration',
    topFilterClicked: 'TopFilter_Clicked',
    searchIconClicked: 'Search_icon_clicked',
    popularAreasClicked: 'Popular_areas_clicked',
    searchTap: 'Search_tap',
    mostPopular: 'Most popular',
    costliestFirst: 'costliest first',
    cheapestFirst: 'Cheapest first',
    userRatings: 'User ratings',
    H_SOLDOUT: 'H_SOLDOUT',
    H_SEARCH_FAIL: 'H_SEARCH_FAIL',
    G_H_SOLDOUT: 'G_H_SOLDOUT',
    G_H_SEARCH_FAIL: 'G_H_SEARCH_FAIL',
    popularFilters: 'pf',
    priceRange: 'pr',
    propertyType: 'pt',
    starRating: 'st',
    userRating: 'ur',
    amenities: 'am',
    location: 'loc',
    reset: 'reset',
    cancel: 'cancel',
    hourlyStayCardClicked: 'HourlyStayCardClicked',
  },
};

export const srpFilters = {
  hourly: {
    hourlyStar: 'Hourly Star Filter',
    hourlyPopular: 'Hourly Popular Filter',
    hourlyProperty: 'Hourly Property Filter',
    hourlyDistance: 'Hourly Distance Filter',
    hourlyLocation: 'Hourly Location Filter',
    hourlyAmenities: 'Hourly Amenities Filter',
    hourlyRating: 'Hourly Rating Filter',
    hourlyPrice: 'Hourly Price Filter',
    hourlyPah: 'Hourly Pah Filter',
    hourlyClearAll: 'Hourly clear all filters',
    hourlyReset: 'Hourly_Reset_Filter',
  },
};
